<!--
 * @Author: DY
 * @Date: 2021-01-27 11:25:31
 * @LastEditTime: 2021-01-29 10:25:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\jnApp\accountsPayable\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="accountsPayable">
            <van-nav-bar
                title="应付账款"
                left-arrow
                @click-left="onClickLeft"
            ></van-nav-bar>
            <section>
                <div class="search-conditions-con">
                    <div class="search-conditions">
                        <span class="time-con" @click="handleShowCalendar">
                            <span>{{ time }}</span>
                        </span>
                    </div>
                </div>
                <div class="main">
                    <div class="top">
                        <div class="header">
                            <div class="item item0">
                                <p class="num">
                                    {{ sumData.payable }}
                                </p>
                                <p class="describe">
                                    累计应付(万元)
                                </p>
                            </div>
                            <div class="item item1">
                                <p class="num">
                                    {{ sumData.actually_paid }}
                                </p>
                                <p class="describe">
                                    累计实付(万元)
                                </p>
                            </div>
                            <div class="item item2">
                                <p class="num">
                                    {{ sumData.payable_rate }}
                                </p>
                                <p class="describe">
                                    付款率(%)
                                </p>
                            </div>
                        </div>
                        <div class="header">
                            <div class="item item3">
                                <p class="num">
                                    {{ sumData.payable_balance }}
                                </p>
                                <p class="describe">
                                    应付账款余额(万元)
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="split"></div>
                    <div class="chart-con">
                        <h4>本年应付账款分析图</h4>
                        <div id="lineChart"></div>
                    </div>
                    <div class="split"></div>
                    <div class="chart-con">
                        <h4>本年付款情况</h4>
                        <!--                        <div id="lineChart2"></div>-->
                        <div class="list-con">
                            <ul v-if="list.length>0">
                                <li v-for="(item, index) in list" :key="index">
                                    <h4>客户名称:{{ item.supplier_name }}</h4>
                                    <div class="static-block">
                                        <div class="static-item">
                                            <div class="num">
                                                {{ item.payable }}
                                            </div>
                                            <div class="lable">
                                                应付金额(万元)
                                            </div>
                                        </div>
                                        <div class="static-item">
                                            <div class="num">
                                                {{ item.actually_paid }}
                                            </div>
                                            <div class="lable">
                                                实付金额(万元)
                                            </div>
                                        </div>
                                        <div class="static-item">
                                            <div class="num">
                                                {{ item.payable_balance }}
                                            </div>
                                            <div class="lable">
                                                应付余额(万元)
                                            </div>
                                        </div>
                                        <div class="static-item rate">
                                            <div class="num">
                                                {{ item.payable_rate }}
                                            </div>
                                            <div class="lable">
                                                付款率
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="no-data" v-else>
                                暂无数据
                            </div>
                        </div>
                    </div>
                </div>
                <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
                    <van-datetime-picker
                        v-model="currentDate"
                        type="year-month"
                        title="选择年月日"
                        @confirm="confirmDate"
                        @cancel="cancelDate"
                    ></van-datetime-picker>
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>

<script>
import bg_green from '@/assets/images/home/bg_green.png';
import bg_yellow from '@/assets/images/home/bg_yellow.png';
export default {
    // 应付账款
    name: 'accounts-payable',
    components: {},
    props: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 当前日期
            time: '',
            // 图表数据
            data: {},
            // 应付合计
            sumData: {},
            currentDate: '',
            list: [], // 供应商应付列表
        };
    },
    watch: {
        time(newVal) {
            const newTime = newVal.split('-');
            const year = newTime[0];
            const month = newTime[1];
            this.$toast.loading();
            // 查询该年度所有应付合计
            const pm1 = this.getPaymentData(year, month);
            // 获取每月应付柱图数据
            const pm2 = this.getMonthlyPayableData(year, month);
            const pm3 = this.getSupplePayList(year, month);
            Promise.all([pm1, pm2, pm3]).then(() => {
                this.$toast.clear();
            });
        },
    },
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.time = year + '-' + month;
        },
        // 选择时间
        handleShowCalendar() {
            this.currentDate = new Date(this.time);
            this.showCalendarPop = true;
        },
        // 确认选择时间
        confirmDate(value) {
            this.time = this.formatDate(value);
            this.showCalendarPop = false;
        },
        // 取消选择时间
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 查询该年度所有应付合计
        async getPaymentData(year, month) {
            await this.$axios
                .get(`/interfaceApi/report/statisticalanalysis/procurement/account/payable/total/${year}/${month}`)
                .then(res => {
                    this.sumData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        async getSupplePayList(year, month) {
            await this.$axios
                .get(`/interfaceApi/report/statisticalanalysis/procurement/account/payable/list/${year}/${month}`)
                .then(res => {
                    this.list = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取每月应付柱图数据
        getMonthlyPayableData(year, month) {
            this.$axios
                .get(`/interfaceApi/report/statisticalanalysis/procurement/account/payable/month/${year}/${month}`)
                .then(res => {
                    const xData = [];
                    // 本月应付
                    const accountsPayable = [];
                    // 本月实付
                    const paidInAccounts = [];
                    res.map(item => {
                        xData.push(item.date);
                        accountsPayable.push(item.payable);
                        paidInAccounts.push(item.actually_paid);
                    });
                    const data = {
                        id: 'lineChart',
                        xData: xData,
                        legend: ['本月应付', '本月实付'],
                        yAxisName: ['万元'],
                        grid: {
                            left: 50,
                            top: 60,
                            right: 10,
                            bottom: 40,
                        },
                        series: [
                            {
                                name: '本月应付',
                                type: 'bar',
                                itemStyle: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: 'rgba(113,198,176,1)', // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: 'rgba(78,164,150,1)', // 100% 处的颜色
                                    }], false),
                                },
                                label: {
                                    show: false,
                                    position: 'top',
                                    fontSize: '12',
                                    color: 'rgba(78,164,150,1)',
                                    lineHeight: 22,
                                    padding: [0, 10, 4, 10],
                                    backgroundColor: {
                                        image: bg_green,
                                    },
                                },
                                barMaxWidth: 15,
                                data: accountsPayable,
                            },
                            {
                                name: '本月实付',
                                type: 'bar',
                                itemStyle: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: 'rgba(242,227,65,1)', // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: 'rgba(220,193,41,1)', // 100% 处的颜色
                                    }], false),
                                },
                                label: {
                                    show: false,
                                    position: 'top',
                                    fontSize: '12',
                                    color: 'rgba(220,193,41,1)',
                                    lineHeight: 22,
                                    padding: [0, 10, 4, 10],
                                    backgroundColor: {
                                        image: bg_yellow,
                                    },
                                },
                                barMaxWidth: 15,
                                data: paidInAccounts,
                            },
                        ],
                    };
                    this.initLineChart(data);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 格式化时间
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            const m = date.getMonth() + 1;
            return y + '-' + m;
        },
        // 柱图
        initLineChart(data, type) {
            const myChart = this.$echarts.init(document.getElementById(data.id));
            const option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: data.legend,
                },
                grid: data.grid,
                xAxis: [
                    {
                        type: 'category',
                        data: data.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [],
                series: data.series,
            };
            if (type === '1') {
                option.xAxis[0].axisLabel.rotate = 0;
            }
            if (data) {
                data.yAxisName.forEach(item => {
                    option.yAxis.push({
                        name: item,
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },);
                });
            }
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.accountsPayable
    background #fff
    width 100%
    height 100%
    section
        height calc(100% - 44rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        .search-conditions-con
            padding 10rpx
            .search-conditions
                font-size 16rpx
                height 45rpx
                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
                border-radius 4rpx
                padding 10rpx 20rpx
                display flex
                justify-content space-around
                line-height 25rpx
                .time-con
                    position relative
                    flex 1
                    text-align center
                .iconfont
                    font-size 14rpx
                    color #979EA7
                    margin-left 5rpx
        .main
            height calc(100% - 65rpx)
            overflow-y auto
            .top
                padding 0 10rpx 10rpx 10rpx
                h4
                    margin-top 10rpx
                    span
                        font-size 12rpx
                        color #979EA7
                .header
                    display flex
                    margin-top 10rpx
                    .item
                        flex-shrink 0
                        width calc(100%/3)
                        text-align center
                        padding 3rpx 0 5rpx 0
                        .describe
                            font-size 12rpx
                            color #979EA7
                        .num
                            font-size 18rpx
                            margin-bottom 3rpx
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        &.item0
                            .num
                                color #5588F1
                        &.item1
                            .num
                                color #FA8436
                        &.item2
                            border 1px solid #DDD4FF
                            background rgba(134, 107, 238, 0.08)
                            .describe
                                color #333333
                            .num
                                color #866BEE
                        &.item3
                            border 1px solid #BAEBF0
                            background rgba(33, 189, 204, 0.08)
                            .describe
                                color #333333
                            .num
                                color #21BDCC
                        &.item4
                            .num
                                color #FFB729
            .split
                background #F0F0F0
                height 15rpx
            .chart-con
                padding 10rpx
                h4
                    margin 10rpx 0
                #lineChart
                    height 235rpx
                #lineChart2
                    height 235rpx
            .list-con
                position: relative
                .no-data
                    font-size 28rpx
                    line-height 200rpx
                    text-align center
                    color #ccc
                li
                    background #FFFFFF
                    box-shadow: 1px 1px 4rpx 0 rgba(84, 148, 243, 0.5)
                    border-radius 4rpx
                    border 1px solid #D7D7D7
                    margin-bottom 15rpx
                    h4
                        height 40rpx
                        background rgba(85, 136, 241, 0.06)
                        border-radius 4rpx 4rpx 0 0
                        line-height 40rpx
                        font-size 14rpx
                        padding-left 15rpx
                        margin 0
                    .static-block
                        display flex
                        flex-shrink 0
                        border-bottom 1px solid #f0f0f0
                        padding 10rpx
                        .static-item
                            width 28%
                            padding-left 2rpx
                            &.rate
                                flex 1
                                padding-top 5rpx
                                padding-left 5rpx
                            .num
                                font-size 16rpx
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                color #666666
                            .lable
                                font-size 12rpx
                                color #979EA7
                            &:nth-child(1)
                                padding-top 5rpx
                            &:nth-child(2)
                                padding-top 5rpx
                            &:nth-child(3)
                                background rgba(250, 132, 54, 0.06)
                                padding 5px
                                .num
                                    color #FF6600
                                .lable
                                    color #666
</style>
